import React from "react";
import { Link } from "react-router-dom";

import {
	IconFeatherHome,
	IconFeatherUser,
	IconMaterialChatBubbleOutline,
	QrCode,
} from "../../Icons/img";

import { Container } from "./styles";

export default function BarNavigationPDV() {
	return (
		<Container id='aside'>
			<nav>
				<ul>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/home/merchant`}>
							<IconFeatherHome />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/scan-qrcode`}>
							<QrCode width={24} heigth={24} />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/pdv-cupons`}>
							<IconMaterialChatBubbleOutline />
						</Link>
					</li>
					<li>
						<Link to={`${process.env.PUBLIC_URL}/pdv-profile`}>
							<IconFeatherUser />
						</Link>
					</li>
				</ul>
				<img
					className='logo-labyes'
					src={require("@/assets/img/logo-labyes.png").default}
					alt='logo labyes'
				/>
			</nav>
		</Container>
	);
}
